module.exports = __webpack_public_path__ + "img/MilestoneIcon.1a8622fb.png";